module.exports = __webpack_public_path__ + "img/job-shield.d5590dbd.svg";